// Shared task ordering used across all task lists (To Do, Dashboard, etc.).
// Default order: due date first, then sort_order — which encodes priority
// (Urgent > High > Medium > Low) at creation, unless the user has manually
// dragged/reordered the task (order_pinned), in which case sort_order wins.
export const dueKey = (t) => t.due_date || "9999-12-31";
export const orderOf = (t) => (t.sort_order != null ? t.sort_order : (t.created_at ? Date.parse(t.created_at) : 0));

export function defaultTaskCompare(a, b) {
  return dueKey(a).localeCompare(dueKey(b)) || orderOf(a) - orderOf(b);
}

export function sortTasksDefault(tasks) {
  return [...(tasks || [])].sort(defaultTaskCompare);
}

// Sub-task ordering: incomplete items keep their manual (array) order on top;
// completed items drop below, sorted by completion time (most recent first).
export function sortSubtasks(list) {
  const arr = list || [];
  const incomplete = arr.filter((s) => !s.completed);
  const complete = arr.filter((s) => s.completed).sort((a, b) => {
    const ta = a.completed_at ? Date.parse(a.completed_at) : 0;
    const tb = b.completed_at ? Date.parse(b.completed_at) : 0;
    return tb - ta;
  });
  return [...incomplete, ...complete];
}
